import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

declare const gtag: any;

const GA_ID = 'G-Z38GF1R6HS';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private iniciado = false;

  constructor(private router: Router) {}

  // Se llama una vez al arrancar la app. Escucha cambios de ruta y envia page_view.
  iniciar(): void {
    if (this.iniciado) return;
    this.iniciado = true;

    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.pageView(this.normalizarUrl(e.urlAfterRedirects));
      });
  }

  // Registra una vista de pagina (ruta normalizada, sin IDs ni query params sensibles)
  pageView(ruta: string): void {
    if (typeof gtag !== 'function') return;
    gtag('event', 'page_view', {
      page_path: ruta,
      page_location: window.location.origin + ruta,
      page_title: document.title,
    });
  }

  // Evento personalizado (para medir acciones: ej. evento('reportar_pago'))
  evento(nombre: string, params: Record<string, any> = {}): void {
    if (typeof gtag !== 'function') return;
    gtag('event', nombre, params);
  }

  // Reemplaza IDs numericos y query strings por placeholders, para no enviar
  // datos sensibles (codigos de cliente, ids de edificio, etc.) a Google.
  private normalizarUrl(url: string): string {
    return url
      .split('?')[0]                          // quita query params
      .replace(/\/\d+/g, '/:id')              // /123 -> /:id
      .replace(/\/[0-9a-f]{8,}/gi, '/:hash'); // hashes largos -> /:hash
  }
}
